module.exports = __webpack_public_path__ + "static/media/puerto.ef7e827c.jpg";